import React, {useEffect, useState} from "react"
import {Modal, Form, Input, Select, Button, InputNumber} from "antd";
import {ProfileTwoTone} from "@ant-design/icons";
import {useModel} from "../../../models";
import {decoder, filterPayType, filterTree} from "../../../utils/decoder"

let {Option} = Select
const TiaoEr = () => {
    let [{accountRow, selectedCustomerRow, ModelVisible}, {adjustAccount, setModelVisible}] = useModel("customerBill")
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue({...accountRow, ...selectedCustomerRow})
        form.setFieldsValue({accountType: "授信账户"})
    }, [accountRow])
    const _onFinish = () => {
        form.validateFields().then(data => {
            let {id, accountType} = accountRow
            let datas = {
                ...data,
                id,
                accountType
            }
            adjustAccount({datas}).then(() => {
                // setAdjustModelVisible(false);
                setModelVisible(!ModelVisible)
            });
        })
    }

    const cancel = () => {
        form.resetFields();
        setModelVisible(!ModelVisible)

    }
    return (
        <Form
            form={form}
            onFinish={_onFinish}
        >
            <Form.Item
                name="customerName"
                label="客户名称"
                labelCol={{span: 5}}
            >
                <Input placeholder="客户名称" disabled/>
            </Form.Item>
            <Form.Item
                name="accountType"
                label="账户类型"
                labelCol={{span: 5}}
            >
                <Input disabled placeholder="账户类型"/>
            </Form.Item>
            <Form.Item
                name="creditLine"
                label="授信额度"
                labelCol={{span: 5}}
            >
                <Input placeholder="授信额度" disabled/>
            </Form.Item>
            <Form.Item
                name="adjustmentlimit"
                label="调整额度"
                labelCol={{span: 5}}
            >
                <InputNumber placeholder="调整额度"/>
            </Form.Item>
            <Form.Item
                labelCol={{span: 5}}
                name="remarks"
                label="备注"
            >
                <Input placeholder="备注"/>
            </Form.Item>
            <Form.Item style={{textAlign: "right"}}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>
        </Form>
    )
}
const ChoZhi = () => {
    const [{payTypeDict, accountTypeDict}, {getPayTypeDict}] = useModel("cmDict");
    // const [{ ModelVisible, ModelParams }, { setModelVisible, setModelParams }] = useModel('customerBill')
    let [{accountRow, selectedCustomerRow, ModelVisible}, {adjustAccount, fillAccount, setModelVisible}] = useModel("customerBill")

    const [form] = Form.useForm();
    useEffect(() => {
        getPayTypeDict();
    }, []);
    useEffect(() => {
        // console.log(accountRow)
        if(!!accountRow){
        form.setFieldsValue({...selectedCustomerRow, ...accountRow})
        form.setFieldsValue({accountType: decoder(accountTypeDict, accountRow.accountType)})
        }
    }, [accountRow])
    const cancel = () => {
        setModelVisible(!ModelVisible)
    }
    const _onFinish = (value) => {

        form.validateFields().then(datas => {
            // console.log(data)
            let {id} = accountRow
            let data = {
                ...datas,
                id,
                accountType: accountRow.accountType
            }
            fillAccount({data}).then(() => {
                // setAdjustModelVisible(false);
                setModelVisible(!ModelVisible)

            });
        })
        // setModelVisible(!ModelVisible)
        //     let data = form.getFieldValue()
        //     console.log(data)
    }
    return (
        <Form
            form={form}
            onFinish={_onFinish}
            labelCol={{span: 6}}
            style={{marginRight: "50px"}}
            initialValues={{
                omitAmount: "0.00"
            }}
        >
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                <Input placeholder="客户名称" disabled/>
            </Form.Item>
            <Form.Item
                name="accountType"
                label="账户类型"
                rules={[{required: true, message: '账户类型是必选项',}]}
            >
                <Input disabled={true} placeholder="账户类型"/>
            </Form.Item>
            <Form.Item
                name="remainingAmount"
                label="剩余金额"
            >
                <Input disabled={true} placeholder="剩余金额"/>
            </Form.Item>
            <Form.Item
                name="rechargeAmount"
                label="充值金额"
                rules={[{required: true, message: '充值金额是必输项',}]}
            >
                <InputNumber placeholder="充值金额"/>
            </Form.Item>
            <Form.Item
                name="omitAmount"
                label="抹零金额"
                rules={[{required: false, message: '抹零金额是必输项',}]}
            >
                <InputNumber placeholder="抹零金额"/>
            </Form.Item>
            <Form.Item
                name="paymentMethod"
                label="支付方式"
                rules={[{required: true, message: '充值方式是必输项',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择支付方式"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={filterPayType(payTypeDict)}
                />
            </Form.Item>
            <Form.Item
                name="remarks"
                label="备注"
            >
                <Input placeholder="备注"/>
            </Form.Item>
            <Form.Item style={{textAlign: "right"}}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>
        </Form>
    )
}
const ZhuanZhang = () => {
    const [{ModelVisible, ModelParams, accountList, accountRow, selectedCustomerRow}, {setModelVisible, setModelParams, transferAccount}] = useModel('customerBill')
    const [{payTypeDict, accountTypeDict}] = useModel("cmDict");
    const initOptions = accountList.map(el => ({
        key: el.id,
        label: decoder(accountTypeDict, el.accountType),
        value: el.id
    }));
    const [sourceAccountOptions, setSourceAccountOptions] = useState(initOptions);
    const [targetAccountOptions, setTargetAccountOptions] = useState(initOptions);
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue({...selectedCustomerRow})
    }, [accountRow])
    const entList = [//支付类型
        {type: "临时授信账户"},
        {type: "授信账户"}
    ]
    const comeList = [
        {type: "预存款账户"},
        {type: "返利账户"},
        {type: "服务费账户"},
        {type: "代金券账户"},
        {type: "订金账户"},
        {type: "服务账户"}
    ]
    const cancel = () => {
        setModelVisible(!ModelVisible)

    }
    const _onFinish = (value) => {
        setModelVisible(!ModelVisible)
        // let data = form.getFieldValue()
        // console.log(data)
        form.validateFields().then(data => {
            transferAccount({data}).then(() => {
                setModelVisible(!ModelVisible);
            });
        })
    }

    const onSourceAccountChange = (value) => {
        const selectedSourceAccount = accountList.filter(el => el.id === value);
        if (selectedSourceAccount && selectedSourceAccount.length > 0) {
            form.setFieldsValue({transferOutId: selectedSourceAccount[0].id});
        }
        const filteredTargetOptions = initOptions.filter(el => !(el.key === value));
        setTargetAccountOptions(filteredTargetOptions)
    }
    const onTargetAccountChange = (value) => {
        const selectedTargetAccount = accountList.filter(el => el.id === value);
        console.log(selectedTargetAccount)
        if (selectedTargetAccount && selectedTargetAccount.length > 0) {
            form.setFieldsValue({transferToId: selectedTargetAccount[0].id});
        }
        setSourceAccountOptions(initOptions.filter(el => !(el.key === value)));
    }
    return (
        <Form
            form={form}
            onFinish={_onFinish}
            labelCol={{span: 6}}
            style={{marginRight: "50px"}}
        >
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                <Input disabled={true} placeholder="客户名称"/>
            </Form.Item>
            <Form.Item
                name="transferOutId"
                label="转出账户"
                rules={[{required: true, message: '转出账户是必输项',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择转出账户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    onChange={onSourceAccountChange}
                    options={sourceAccountOptions}
                />
            </Form.Item>
            <Form.Item
                name="transferToId"
                label="转入账户"
                rules={[{required: true, message: '转入账户是必输项',}]}
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择转入账户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    onChange={onTargetAccountChange}
                    options={targetAccountOptions}
                />
            </Form.Item>
            <Form.Item
                name="transferAmount"
                label="转账金额"
                rules={[{required: true, message: '转账金额是必输项',}]}
            >
                <InputNumber placeholder="转账金额"/>
            </Form.Item>
            <Form.Item
                name="remarks"
                label="备注"
            >
                <Input placeholder="备注"/>
            </Form.Item>
            <Form.Item style={{textAlign: "right"}}>
                <Button className="margin-left-8" onClick={cancel}>取消</Button>
                <Button className="margin-left-8" type="primary" htmlType="submit">确定</Button>
            </Form.Item>

        </Form>
    )
}
const ModelCont = {
    "tiaoer": <TiaoEr/>,
    "chozhi": <ChoZhi/>,
    "zhuanzhang": <ZhuanZhang/>,
}
const SupplierModel = () => {
    const [{ModelVisible, ModelParams}, {setModelVisible, setModelParams}] = useModel('customerBill')
    const handleOk = (e) => {//确认按钮
        console.log("确认")
        setModelVisible(!ModelVisible)
        setModelParams({})
    };
    const handleCancel = (e) => {//取消按钮
        console.log("取消")
        setModelVisible(!ModelVisible)
        setModelParams({})
    }
    return (
        <Modal
            title={ModelParams.title}
            visible={ModelVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
        >
            {/* <TiaoEr></TiaoEr> */}
            {/* <ChoZhi></ChoZhi> */}
            {/* <ZhuanZhang></ZhuanZhang> */}
            {ModelCont[ModelParams.type]}
        </Modal>
    )
}
export default SupplierModel